import { render, staticRenderFns } from "./newProduct.vue?vue&type=template&id=58fa5c72&scoped=true"
import script from "./newProduct.vue?vue&type=script&lang=js"
export * from "./newProduct.vue?vue&type=script&lang=js"
import style0 from "./newProduct.vue?vue&type=style&index=0&id=58fa5c72&prod&scoped=true&lang=css"
import style1 from "./newProduct.vue?vue&type=style&index=1&id=58fa5c72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa5c72",
  null
  
)

export default component.exports